import { createActionHelpers } from 'vuex-loading';
import Big from 'big.js';
import localForage from 'localforage';
import Auth from '@js/plugins/auth';
import * as type from '../mutation-types';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const store = localForage.createInstance({
    storeName: `reimbursement_${Auth.user().id}`,
    namespaced: true,
});

const Laroute = require('../../laroute');

store.getItem('filters').then(filters => {
    if (filters) {
        state.filters = filters;
    }
});

const state = {
    searchMeta: null,
    filters: [],
    epsCardList: [],
    shellAppCardList: [],
    lastQuery: null,
};

const mutations = {
    [type.SET_EPS_CARD_LIST](state, eps) {
        state.epsCardList = eps;
    },

    [type.SET_SHELL_APP_CARD_LIST](state, shell_app) {
        state.shellAppCardList = shell_app;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    async setFilters(state, filters) {
        state.filters = filters;
        await store.setItem('filters', filters);
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const actions = {
    getEPSCardListIfNecessary({ commit, dispatch }, params = {}) {
        const route = Laroute.route('franchise.vue.epsCards');

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-shell-reimbursement');

        return axios
            .get(route, options)
            .then(res => {
                let data = res.data.data;

                commit(type.SET_EPS_CARD_LIST, data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-shell-reimbursement');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-shell-reimbursement');
                throw err;
            });
    },

    getShellAppCardListIfNecessary({ commit, dispatch }, params = {}) {
        const route = Laroute.route('franchise.vue.shellAppCards');

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-shell-reimbursement');

        return axios
            .get(route, options)
            .then(res => {
                let data = res.data.data;

                commit(type.SET_SHELL_APP_CARD_LIST, data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-shell-reimbursement');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-shell-reimbursement');
                throw err;
            });
    },

    getSearchMeta({ commit, dispatch }) {
        const route = Laroute.route(
            'franchise.report.shell_reimbursement.search.meta',
        );

        startLoading(dispatch, 'get-shell-reimbursement');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-shell-reimbursement');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-shell-reimbursement');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
